<template>
  <div class="flex justify-between items-center gap-1 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800">
    <button
      type="button"
      class="p-2 border-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-l-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      :disabled="modelValue <= min"
      @click="decrease"
      aria-label="Decrease quantity"
    >
      <Icon name="i-heroicons-minus" class="w-4 h-4" />
    </button>
    <input
      :value="modelValue"
      @input="handleInput"
      type="text"
      class="w-full text-center border-0 bg-transparent dark:text-gray-100 focus:outline-none focus:ring-0 text-sm font-medium"
      readonly
    />
    <button
      type="button"
      class="p-2 border-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-r-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      :disabled="max !== undefined && modelValue >= max"
      @click="increase"
      aria-label="Increase quantity"
    >
      <Icon name="i-heroicons-plus" class="w-4 h-4" />
    </button>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  modelValue: number
  min?: number
  max?: number
}>(), {
  min: 1
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>()

function decrease() {
  if (props.modelValue > props.min) {
    emit('update:modelValue', props.modelValue - 1)
  }
}

function increase() {
  if (props.max === undefined || props.modelValue < props.max) {
    emit('update:modelValue', props.modelValue + 1)
  }
}

function handleInput(event: Event) {
  const value = parseInt((event.target as HTMLInputElement).value) || props.min
  emit('update:modelValue', Math.max(props.min, props.max ? Math.min(value, props.max) : value))
}
</script>
